import Chip from "@mui/material/Chip";
import type { BatchJobStatus } from "../../../../lib/corpusApi";

const STATUS_MAP: Record<
  BatchJobStatus,
  { label: string; color: "default" | "info" | "success" | "error" | "warning" }
> = {
  queued: { label: "Queued", color: "default" },
  running: { label: "Running", color: "info" },
  paused: { label: "Paused", color: "warning" },
  completed: { label: "Completed", color: "success" },
  failed: { label: "Failed", color: "error" },
  cancelled: { label: "Cancelled", color: "default" },
};

export interface BatchJobStatusBadgeProps {
  status: BatchJobStatus;
}

/** Chip rendering the lifecycle status of a batch job. */
export function BatchJobStatusBadge({ status }: BatchJobStatusBadgeProps) {
  const { label, color } = STATUS_MAP[status];
  return <Chip label={label} color={color} size="small" />;
}
